import React, { useState } from "react";

export const FormContext = React.createContext({});

export const FormProvider = ({children, initialData}) => {
    const dataKeys = Object.keys(initialData);

    let initialErrors = {}
    dataKeys.map((dataKey) => initialErrors[dataKey] = false);

    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState(initialErrors);

    return (
        <FormContext.Provider value={{data, setData, errors, setErrors}}>
            {children}
        </FormContext.Provider>
    )
}